import { render, staticRenderFns } from "./carouselProductImage.vue?vue&type=template&id=040341aa&scoped=true"
import script from "./carouselProductImage.vue?vue&type=script&lang=js"
export * from "./carouselProductImage.vue?vue&type=script&lang=js"
import style0 from "./carouselProductImage.vue?vue&type=style&index=0&id=040341aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040341aa",
  null
  
)

export default component.exports